import React from 'react';
import { useCapabilities } from '../hooks/useCapabilities.js';
import { useAccount } from '../lib/account.jsx';
import { featureAccess } from '../lib/featureAccess.js';
export function FeatureBadge({ feature }) {
    const access = featureAccess(feature, useAccount(), useCapabilities());
    return <span className="tag key">{access.label}</span>;
}
export function AccessExplanation({ feature }) {
    const access = featureAccess(feature, useAccount(), useCapabilities());
    return <p className="feature-access-note">{access.message}</p>;
}
